import { Component } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
@Component({
    selector: 'options-supp',
    templateUrl: 'options-supp.component.html',
    styleUrls: ['options-supp.component.scss']
})
export class OptionsSuppComponent {
    options: any = [];
    bouncIn = false;
    constructor(
        public bsModalRef: BsModalRef
    ) {
        setTimeout(
            () => {
                this.options[0].checked = true;
                this.bouncIn = true;
                setTimeout(
                    () => {
                        this.options[0].checked = false;
                        this.bouncIn = false;
                    }, 500
                )
            }, 500
        )
    }
    valider() {
        this.bsModalRef.hide();
    }
}